import { useCallback, useState } from 'react';
import createUseContext from 'constate';

const useGlobalStore = () => {
  const [
    activityModalHasBeenShowed,
    stateSetActivityModalHasBeenShowed,
  ] = useState(false);

  const setActivityModalHasBeenShowed = useCallback(() => {
    stateSetActivityModalHasBeenShowed(true);
  }, [stateSetActivityModalHasBeenShowed]);

  return {
    activityModalHasBeenShowed,
    setActivityModalHasBeenShowed,
  };
};

const [GlobalStoreProvider, useGlobalStoreContext] = createUseContext(useGlobalStore);

export {
  GlobalStoreProvider,
  useGlobalStoreContext,
};
